"use strict";exports.f={}.propertyIsEnumerable;